import { Component } from '@angular/core';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';


@Component({
  selector: 'app-transfer-banks-cashs',
  templateUrl: './transfer-banks-cashs.component.html',
  styleUrls: ['./transfer-banks-cashs.component.scss']
})
export class TransferBanksCashsComponent {

  permissionType = PermissionTypeEnum;
  history = 0;

  constructor(
    private authService: AuthenticationService,

  )
  {
    var permissions = authService.getPermissions();
  }

}
